import { Component, inject } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { AuthStore } from '../../store/auth.store';
import { TranslocoDirective } from '@jsverse/transloco';
import { TRANSLOCO_SCOPE } from '../../constants/i18n.constants';
import { provideAuthTranslocoScope } from '../../providers/i18n.providers';

@Component({
  imports: [NzButtonModule, TranslocoDirective],
  selector: 'auth-login-button',
  templateUrl: './login-button.component.html',
  providers: [provideAuthTranslocoScope()],
})
export class LoginButtonComponent {
  private authStore = inject(AuthStore);
  protected readonly translocoPrefix = TRANSLOCO_SCOPE

  handleLogin() {
    this.authStore.login('/callback');
  }
}
